import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useCallback } from 'react';
/**
 * Emulate `hover` state in javascript.
 *
 * @example
 * const { isHovering, bind } = useHoverState();
 * return <button {...bind}>Hover me</button>
 */

export function useHoverState() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovering = _useState2[0],
      setIsHovering = _useState2[1];

  var onMouseEnter = useCallback(function () {
    setIsHovering(true);
  }, []);
  var onMouseLeave = useCallback(function () {
    setIsHovering(false);
  }, []);
  return {
    isHovering: isHovering,
    bind: {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }
  };
}